import Api from './api';

const ParkingService = {
  parking: (params) => Api.post('/adm/startParking', params, { headers: {'Authorization': sessionStorage.getItem('token')} }),

  renew: (params) => Api.post('/adm/renewParking', params, { headers: {'Authorization': sessionStorage.getItem('token')} }),

  rules: (params) => Api.post('/availableRules', params, { headers: {'Authorization': sessionStorage.getItem('token')} }),
}

export default ParkingService;
